<template>

    <div class="page">
        <div class="gridheader">
            <div class="row wrapper">
                <div class="col-md-4 title">
                    <div class="row">
                        <div class="col-12 namescol">
                            <h1>{{$t('ORDERS')}}</h1>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="text-left">
                                <b-form-checkbox v-model="pagination.showAll" class="grey"><span class="label">{{$t('SHOWALL')}}</span></b-form-checkbox>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div v-if="globals.auth == 9">
                                <label>{{$t('COMPANY')}}</label>
                                <select v-model="pagination.ordererCompanyId" class="form-control">
                                    <option :value="null">{{ $t('ALL') }}</option>
                                    <option v-for="item in dentalsolutionsorderercompanies.root" :value="item.ordererCompanyId" :key="item.ordererCompanyId">{{ item.companyName }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4 action d-none d-md-block"><a v-if="globals.auth != 9" v-on:click="addDentalSolution" class="btn btn-primary"><img src="../assets/img/icon-add-item.svg" alt=""> {{$t('ADDDENTALSOLUTION')}}</a></div>
            </div>
        </div>
        <div class="row" v-if="dentalsolutions.root.length == 0">
            <div class="col-12 center nothing">
                <img src="../assets/img/icon-novi-nalog-large.svg" alt="">
                <p>{{$t('CURRENTLYNOORDERS')}}</p>
                <a v-on:click="addDentalSolution" class="btn btn-primary"><img src="../assets/img/icon-add-item.svg" alt=""> {{$t('ADDDENTALSOLUTION')}}</a>
            </div>
        </div>
        <div class="row" v-if="dentalsolutions.root.length > 0">
            <div class="table-responsive">
                <table class="maintable">
                    <thead>
                        <tr>
                            <td>{{$t('NUM')}}</td>
                            <td>{{$t('ORDEREDON')}}</td>
                            <td>{{$t('OPENEDBY')}}</td>
                            <td>{{$t('NOTIFYDATE')}}</td>
                            <td>{{$t('PRODUCT')}}</td>
                            <td>{{$t('QUANTITY')}}</td>
                            <td>{{$t('STLFILESNUM')}}</td>
                            <td>{{$t('STATUS')}}</td>
                            <td>{{$t('NOTICE')}}</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="dentalsolution in dentalsolutions.root" :key="dentalsolution.dentalSolutionId">
                            <td class="d-none d-md-table-cell" v-on:click="toDentalSolution(dentalsolution.dentalSolutionId)">{{dentalsolution.dentalSolutionId}}</td>
                            <td class="d-none d-md-table-cell" v-on:click="toDentalSolution(dentalsolution.dentalSolutionId)">{{formatDate(dentalsolution.openDateTime)}}</td>
                            <td class="d-none d-md-table-cell" v-on:click="toDentalSolution(dentalsolution.dentalSolutionId)">{{dentalsolution.name}} {{dentalsolution.surname}}</td>
                            <td class="d-none d-md-table-cell" v-on:click="toDentalSolution(dentalsolution.dentalSolutionId)">{{formatDate(dentalsolution.notifyDate, 'DD.MM.YYYY.')}}</td>
                            <td class="d-none d-md-table-cell" v-on:click="toDentalSolution(dentalsolution.dentalSolutionId)">{{$t(dentalsolution.product)}}</td>
                            <td v-on:click="toDentalSolution(dentalsolution.dentalSolutionId)">{{dentalsolution.num}}</td>
                            <td v-on:click="toDentalSolution(dentalsolution.dentalSolutionId)">{{dentalsolution.files ? dentalsolution.files.length : 0}}</td>
                            <td v-on:click="toDentalSolution(dentalsolution.dentalSolutionId)" class="status" v-bind:class="dentalsolution.status">{{dentalsolution.statusOut}}</td>
                            <td><img v-b-tooltip.hover :title="dentalsolution.notice" v-if="dentalsolution.notice !== ''" src="../assets/img/icon-chat-grey.svg" alt=""></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <b-pagination align="center" v-if="dentalsolutions.totalCount > 20" :total-rows="parseInt(dentalsolutions.totalCount)" v-model="pagination.currentPage" :per-page="pagination.limit"></b-pagination>

        <b-modal centered size="sm" ref="newdentalsolution" id="newdentalsolution" v-bind:ok-title="$t('SAVE')" v-bind:cancel-title="$t('CANCEL')" v-on:ok="saveDentalSolution" v-bind:title="$t('NEWDENTALSOLUTION')">
            <form method="get" action="">
                <div class="row">
                    <div class="col-md-12">
                        <inputvalidation v-bind:label="$t('DENTALSOLUTIONCOMPANY')" :formerror="formError" name="workerCompanyId">
                            <autocomplete v-bind:setvalue="setWorkerCompanyId" v-bind:value="formData.workerCompanyId" v-bind:placeholder="$t('DENTALSOLUTIONCOMPANY')" v-bind:values="getDentalSolutionCompanies" v-bind:initdata="getDentalSolutionCompaniesInit"></autocomplete>
                        </inputvalidation>
                    </div>
                </div>
                <p class="bg-danger" v-if="formError.error && formError.notice">{{formError.notice}}</p>
                <div class="clearfix"></div>
            </form>
        </b-modal>

    </div>



</template>

<script>
import
{
    mapActions,
    mapGetters
}
from 'vuex'
import Vue from 'vue'
import dentalsolutionsApi from '@/api/dentalsolutions'

export default
{
    name: 'DentalSolutions',
    data: function()
    {
        var me = this;
        return {
            dentalsolutions:
            {
                root: [],
                totalCount: 0
            },
            dentalsolutionsorderercompanies:
            {
                root: [],
                totalCount: 0
            },
            formData:
            {
                id: '',
                workerCompanyId: '',
            },
            formError:
            {},
            pagination:
            {
                query: '',
                currentPage: 1,
                limit: 20,
                showAll: false,
                ordererCompanyId: null,
            }
        };
    },
    created: async function()
    {
        var me = this;

        await dentalsolutionsApi.deleteOpened(); 

        this.getDentalSolutions();
        this.getDentalSolutionOrdererCompanies();
    },
    methods:
    {
        ...mapActions(
        {
            getDentalSolutionCompaniesInit: 'getDentalSolutionCompanies',
        }),
        toDentalSolution: function(dentalSolutionId)
        {
            var me = this;
            me.$router.push('/dentalsolutions/' + dentalSolutionId)
        },
        saveDentalSolution: function(bvEvt)
        {
            var me = this;
            bvEvt.preventDefault();

            dentalsolutionsApi.saveDentalSolution(me.formData, function(val)
            {
                if (val.error)
                {
                    if (typeof val.notice == 'object')
                    {
                        var notice = '';
                        for (var key in val.notice)
                        {
                            notice += val.notice[key];
                        }
                        val.notice = notice;
                    }
                    me.formError = val;
                }
                else
                {
                    me.$refs.newdentalsolution.hide()
                    me.$router.push('/dentalsolutions/' + val.lastId)
                }
            })
        },
        getDentalSolutions: function()
        {
            var me = this;
            dentalsolutionsApi.getDentalSolutions(me.getParams, function(data)
            {
                if (data.error && data.error == true)
                {
                    Vue.$notify.error(data.notice);
                    return;
                }
                me.dentalsolutions = data;
            });
        },
        getDentalSolutionOrdererCompanies: function()
        {
            var me = this;
            dentalsolutionsApi.getDentalSolutionOrdererCompanies({}, function(data)
            {
                if (data.error && data.error == true)
                {
                    Vue.$notify.error(data.notice);
                    return;
                }
                me.dentalsolutionsorderercompanies = data;
            });
        },
        deleteDentalSolution: function(id)
        {
            var me = this;
            me.$store.commit('setModalAlert',
            {
                text: me.$i18n.t('AREYOUSHURE'),
                btnAction: function()
                {
                    dentalsolutionsApi.deleteDentalSolution(
                    {
                        id: id
                    }, function(data)
                    {
                        if (data.error && data.error == true) me.$notify.error(data.notice);
                        else me.$notify.success(data.notice);
                        me.getDentalSolutions();
                    })
                }
            })
        },
        addDentalSolution()
        {
            var me = this;

            if(me.globals.defaultDentalSolutionsCompanyId.trim() != '' && me.globals.defaultDentalSolutionsUserId.trim() != '')
            {
                dentalsolutionsApi.saveDentalSolution(me.formData, function(val)
                {
                    if (val.error)
                    {
                        Vue.$notify.error(val.notice);
                    }
                    else
                    {
                        me.$router.push('/dentalsolutions/' + val.lastId)
                    }
                })
                return;
            }


            me.formData = {
                id: '',
                workerCompanyId: '',
            };

            me.$refs.newdentalsolution.show()
        },
        setWorkerCompanyId: function(data)
        {
            var me = this;
            me.formData.workerCompanyId = data;
        },
    },
    watch:
    {
        saveDentalSolutionResponse: function(val)
        {
            var me = this;

            me.formError = {};

            if (val.error == true)
            {
                if (typeof val.notice == 'object')
                {
                    me.formError = val.notice;
                    val.notice = '';
                }
            }
            else
            {
                this.$refs.newdentalsolution.hide()
                me.getDentalSolutions();
                for (var key in me.formData)
                {
                    me.formData[key] = '';
                }
            }
        },
        'pagination.query': function()
        {
            var me = this;
            me.getDentalSolutions();
        },
        'pagination.currentPage': function(newValue, oldValue)
        {
            var me = this;
            me.getDentalSolutions();
        },
        'pagination.showAll': function()
        {
            var me = this;
            me.getDentalSolutions();
        },
        'pagination.ordererCompanyId': function()
        {
            var me = this;
            me.getDentalSolutions();
        },
    },
    computed:
    {
        ...mapGetters([
            'modalAlert',
            'dentalSolutionCompanies',
            'globals'
        ]),
        getParams: function()
        {
            var me = this;
            var data = Object.assign(
            {}, me.pagination,
            {});
            data.start = (data.currentPage - 1) * data.limit;
            return data;
        },
        getDentalSolutionCompanies: function()
        {
            var me = this,
                options = [];

            for (var i = 0; i < me.dentalSolutionCompanies.root.length; i++)
            {
                var company = me.dentalSolutionCompanies.root[i];
                options.push(
                {
                    value: company.companyId,
                    text: company.companyName
                })
            }

            return options;
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/DentalSolutions.vue